export function getApiErrorMessage(error) {
    const data = error?.response?.data;
    if (data == null)
        return undefined;
    if (typeof data === "string" && data.trim())
        return data.trim();
    if (typeof data !== "object")
        return undefined;
    const d = data;
    const message = d.message;
    if (typeof message === "string" && message.trim())
        return message.trim();
    const detail = d.detail;
    if (typeof detail === "string" && detail.trim())
        return detail.trim();
    if (Array.isArray(detail) && detail.length > 0) {
        const first = detail[0];
        if (typeof first === "string")
            return first;
        if (first && typeof first === "object" && "msg" in first) {
            const m = first.msg;
            if (typeof m === "string" && m.trim())
                return m.trim();
        }
    }
    return undefined;
}
